"use strict";

var _taggedTemplateLiteral = require("/Users/satoshi/Documents/botlogy/projects/Ikitsuke-clinic/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  overflow-x: scroll;\n  padding: 3rem ", ";\n  min-height: 65vh;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  padding: 3rem 0;\n  width: 100%;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  font-size: var(--font-size-large);\n\n  & *[class] {\n    font-size: inherit;\n\n    &:hover {\n      /* hover\u6642\u306B\u8272\u304C\u5909\u308F\u308B\u306E\u3092\u7121\u52B9\u5316 */\n      color: var(--color-grey-dark-2);\n    }\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n\n  padding: 0 ", ";\n\n  position: relative;\n\n  /* delete button \u306F\u80CC\u666F\u900F\u660E\u306E\u4F59\u767D\u304C\u751F\u3058\u308B\u306E\u3067 position: absolute; \u3067\u8ABF\u6574 */\n  & [data-meta='delete-button'] {\n    position: absolute;\n    right: 3rem;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  padding: 4rem 0;\n  background-color: #fff;\n  box-shadow: var(--box-shadow-default);\n\n  /* current node \u304C overflow \u3057\u3001scroll\u3059\u308B\u969B\u306E\u7E01\u3068\u306E\u82E5\u5E72\u306E\u9699\u9593\u3068\u3057\u3066 border \u3092\u6307\u5B9A */\n  border: 0.5rem solid #fff;\n\n  max-width: 70vw;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = __importDefault(require("styled-components"));

var HORIZONTAL_GAP = '5rem';
exports.StyledCurrentNodeViewWrapperDiv = styled_components_1.default.div(_templateObject());
exports.StyledCurrentNodeTopDiv = styled_components_1.default.div(_templateObject2(), HORIZONTAL_GAP);
exports.StyledCurrentNodeTitleDiv = styled_components_1.default.div(_templateObject3());
exports.StyledCurrentNodeDiv = styled_components_1.default.div(_templateObject4());
exports.StyledCurrentNodeScrollViewDiv = styled_components_1.default.div(_templateObject5(), HORIZONTAL_GAP);